import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { DateRange } from './dateRange.types';

export const useDateRanges = () => {
  return useQuery<AxiosResponse<DateRange[]>>('date-ranges', () => apiClient.get<DateRange[]>('/date-ranges'));
};
